import { Radio, RadioGroup } from "@headlessui/react";
import React from "react";

import { radiobutton1 } from "../../klantenregister";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const RPRadioButtonSmall = ({
  legend,
  keyHoofd,
  categorie,
  updateKlachten,
  valueRadio,
  admin = null,
}) => {
  const raw =
    typeof valueRadio === "number"
      ? valueRadio
      : valueRadio && typeof valueRadio === "object"
        ? valueRadio.value
        : undefined;
  const groupValue = raw === null || raw === undefined ? undefined : raw;

  const onChangeRadio = (id) => {
    updateKlachten(categorie, keyHoofd, id);
  };

  return (
    <fieldset className="mb-5 rounded-xl border border-wa-border/70 bg-wa-panel/40 p-3 shadow-sm ring-1 ring-black/[0.03] dark:bg-wa-panel2/25 dark:ring-white/[0.04] sm:p-4">
      <legend className="text-left text-[13px] font-semibold leading-snug text-wa-text sm:text-sm">
        {legend}
      </legend>
      <RadioGroup
        value={groupValue}
        onChange={onChangeRadio}
        className="mt-3 grid w-full grid-cols-4 gap-1.5 sm:gap-2"
      >
        {radiobutton1.map((option) => (
          <Radio
            key={option.id}
            value={option.id}
            disabled={admin != null}
            className={({ focus, checked }) =>
              classNames(
                "flex min-h-[2.75rem] cursor-pointer items-center justify-center rounded-lg border px-1 py-2 text-center text-xs font-bold tabular-nums transition sm:min-h-[3rem] sm:px-2 sm:text-sm",
                focus ? "ring-2 ring-wa-accent ring-offset-2 ring-offset-wa-app" : "",
                admin != null ? "cursor-not-allowed opacity-60" : "",
                checked
                  ? "border-wa-accent bg-wa-accent text-wa-onaccent shadow-sm"
                  : "border-wa-border bg-wa-panel2 text-wa-text hover:border-wa-accent/50 hover:bg-wa-hover dark:bg-wa-panel/60"
              )
            }
          >
            {option.id}
          </Radio>
        ))}
      </RadioGroup>
    </fieldset>
  );
};

export default RPRadioButtonSmall;
